import clsx from 'clsx';
import { PropsWithChildren, SyntheticEvent } from 'react';

import { Button, TButtonProps } from '../button';
import styles from './icon-button.module.scss';

interface IconProps {
  size?: 'sm' | 'md' | 'lg';
  variant?: 'primary' | 'secondary';
  showBorder?: boolean;
}

interface IconButtonProps extends PropsWithChildren {
  onClick: (event: SyntheticEvent) => void;
  buttonProps?: TButtonProps;
  iconProps?: IconProps;
  type: 'button' | 'icon';
}

const IconButton = ({
  buttonProps,
  children,
  iconProps,
  onClick,
  type = 'button',
}: IconButtonProps) => {
  const props = iconProps || {};

  if (type === 'icon') {
    return (
      <div
        className={clsx(
          styles.button,
          styles[`button__${props.showBorder ? 'border' : ''}`],
          styles[`button__${props.size}`],
          styles[`button__${props.variant}`],
        )}
        onClick={onClick}
      >
        {children}
      </div>
    );
  }

  return <Button iconStart={children} onClick={onClick} {...buttonProps} />;
};

export { IconButton };
